<div #wrapper class="wrapper">
  <mat-progress-bar
    *ngIf="loading || importingFromExistIds.length > 0"
    mode="indeterminate"
  ></mat-progress-bar>
  <table
    mat-table
    #table
    [dataSource]="products"
    multiTemplateDataRows
    matSort
    (matSortChange)="sortData($event)"
  >
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
      <td mat-cell *matCellDef="let product">
        <a [routerLink]="['/product', product.id]" target="_blank">
          {{ product.id }}
        </a>
      </td>
      <td mat-footer-cell *matFooterCellDef>{{ getCol() }}</td>
    </ng-container>
    <ng-container matColumnDef="mobileRow">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Товар</th>
      <td mat-cell *matCellDef="let product; let index = dataIndex">
        <div class="mobileRow">
          <div class="imageWrapper">
            <div class="hoverImg" (contextmenu)="onRightClick($event, product)">
              <div *ngIf="isImportingFromExist(product.id)" class="imageLoadingOverlay">
                <mat-spinner diameter="28"></mat-spinner>
              </div>
              <div *ngIf="!getImg(product)" class="no-photo">
                <mat-icon>photo_camera</mat-icon>
              </div>
              <img *ngIf="getImg(product)" [src]="getImg(product)" class="thumbImg" alt="" />
              <img *ngIf="getImg(product)" [src]="getImg(product)" class="openImg" alt="" />
            </div>
          </div>
          <div class="combineDescription">
            <div class="id">
              ID: <a [routerLink]="['/product', product.id]" target="_blank"> {{ product.id }} </a>
            </div>
            <div class="title">
              <span>{{ product.description }}</span>
            </div>
            <div class="brand">
              <a [routerLink]="['/brand', product.brand.id]" target="_blank">{{
                product.brand.description
              }}</a>
            </div>
            <div class="article">арт. {{ product.article }}</div>
            <div class="stockWithRetailWrapper">
              <span *ngIf="getAddressLabel(product)">{{ getAddressLabel(product) }}</span>
              <span> {{ supportService.formatMoney(product.retail) }}</span>
              <span> {{ supportService.formatMoney(product.price) }}</span>
              <app-product-stock-list [product]="product" [receiverWarehouseId]="mainWarehouse?.id"></app-product-stock-list>
            </div>
            <div class="cart">
              <button
                mat-icon-button
                *ngIf="!productInCart(product.id)"
                (click)="addToCart(product)"
                color="primary"
              >
                <mat-icon>add_shopping_cart</mat-icon>
              </button>
              <mat-form-field *ngIf="productInCart(product.id)" class="drop-padding quanCatalogue">
                <mat-label>Кол-во</mat-label>
                <input
                  matInput
                  type="number"
                  name="quan"
                  (keypress)="focusNext($event, index, 'quan')"
                  [formControl]="getProductCartControl(product.id)"
                  (input)="changeCartQuan(product, $event)"
                  placeholder="Кол-во"
                />
                <button
                  matSuffix
                  mat-icon-button
                  color="warn"
                  aria-label="Удалить"
                  type="button"
                  (click)="removeFromCart(product)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <button mat-icon-button (click)="openAnalogies(product)">
                <mat-icon>compare_arrows</mat-icon>
              </button>
              <button
                mat-icon-button
                (click)="openStockDetails(product)"
                matTooltip="Адресные остатки"
              >
                <mat-icon>inventory_2</mat-icon>
              </button>
              <button mat-icon-button (click)="openScanner(product)" matTooltip="Открыть сканер">
                <mat-icon>qr_code_scanner</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef>{{ getCol() }}</td>
    </ng-container>
    <ng-container matColumnDef="combineDescriptionWithId">
      <th mat-header-cell *matHeaderCellDef>Описание</th>
      <td mat-cell *matCellDef="let product">
        <div class="combineDescription">
          <div class="id">
            <a [routerLink]="['/product', product.id]" target="_blank"> {{ product.id }} </a>
          </div>
          <div class="title">
            <span>{{ product.description }}</span>
          </div>
          <div class="brand">
            <a [routerLink]="['/brand', product.brand.id]" target="_blank">{{
              product.brand.description
            }}</a>
          </div>
          <div class="article">{{ product.article }}</div>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef>{{ getCol() }}</td>
    </ng-container>
    <ng-container matColumnDef="combineDescription">
      <th mat-header-cell *matHeaderCellDef>Описание</th>
      <td mat-cell *matCellDef="let product">
        <div class="combineDescription">
          <div class="title">{{ product.description }}</div>
          <div class="brand">
            <a [routerLink]="['/brand', product.brand.id]" target="_blank">{{
              product.brand.description
            }}</a>
          </div>
          <div class="article">{{ product.article }}</div>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="image">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let product">
        <div class="hoverImg" (contextmenu)="onRightClick($event, product)">
          <div *ngIf="isImportingFromExist(product.id)" class="imageLoadingOverlay">
            <mat-spinner diameter="28"></mat-spinner>
          </div>
          <div *ngIf="!getImg(product)" class="no-photo">
            <mat-icon>photo_camera</mat-icon>
          </div>
          <img *ngIf="getImg(product)" [src]="getImg(product)" class="thumbImg" alt="" />
          <img *ngIf="getImg(product)" [src]="getImg(product)" class="openImg" alt="" />
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Наименование</th>
      <td mat-cell *matCellDef="let product">
        {{ product.description }}
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="descriptionSelector">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Наименование</th>
      <td
        mat-cell
        class="descriptionSelection"
        (click)="toggleProduct(product)"
        *matCellDef="let product"
        [ngClass]="{ disabledDescriptionSelection: isLoading(product) }"
      >
        {{ product.description }}
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Производитель</th>
      <td mat-cell *matCellDef="let product">
        <a [routerLink]="['/brand', product.brand.id]" target="_blank">{{
          product.brand.description
        }}</a>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="article">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Артикул</th>
      <td mat-cell *matCellDef="let product">
        {{ product.article }}
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="retail">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Розница</th>
      <td mat-cell *matCellDef="let product">
        <span
          (contextmenu)="onRightClick($event, product)"
          [matTooltip]="supportService.formatMoney(product.price)"
          matTooltipPosition="left"
        >
          {{ supportService.formatMoney(product.retail) }}</span
        >
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="updateRetail">
      <th mat-header-cell *matHeaderCellDef>Автоцена</th>
      <td mat-cell *matCellDef="let product">
        <button
          mat-icon-button
          type="button"
          class="autoRetailButton"
          [ngClass]="{ active: product.updateRetail, disable: !product.updateRetail }"
          [disabled]="isUpdateRetailLoading(product.id)"
          [matTooltip]="
            product.updateRetail ? 'Автообновление цены включено' : 'Автообновление цены выключено'
          "
          [attr.aria-label]="
            product.updateRetail ? 'Выключить автообновление цены' : 'Включить автообновление цены'
          "
          (click)="toggleUpdateRetail(product)"
        >
          <mat-icon>{{
            isUpdateRetailLoading(product.id)
              ? 'hourglass_top'
              : product.updateRetail
              ? 'lock_open'
              : 'lock'
          }}</mat-icon>
        </button>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="combineRetailWithStock">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Розница</th>
      <td mat-cell *matCellDef="let product">
        <div class="stockWithRetailWrapper">
          <span *ngIf="getAddressLabel(product)">{{ getAddressLabel(product) }}</span>
          <span> {{ supportService.formatMoney(product.retail) }}</span>
          <app-product-stock-list [product]="product" [receiverWarehouseId]="mainWarehouse?.id"></app-product-stock-list>
          <div class="addressActions">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              (click)="openStockDetails(product)"
            >
              Остатки
            </button>
            <button mat-stroked-button color="primary" type="button" (click)="openScanner(product)">
              Сканер
            </button>
          </div>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="retailControl">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Розница</th>
      <td mat-cell *matCellDef="let product; let index = dataIndex">
        <mat-form-field class="retailControl drop-padding">
          <mat-label>Розница</mat-label>
          <input
            matInput
            type="number"
            name="retail"
            (keypress)="focusNext($event, index, 'retail')"
            (input)="handleControlChanges(getProductGroupControl(product))"
            [formControl]="getRetailControl(getProductGroupControl(product))"
          />
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>{{ getRetailControlSum() }}</td>
    </ng-container>
    <ng-container matColumnDef="quanControl">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Кол-во</th>
      <td mat-cell *matCellDef="let product; let index = dataIndex">
        <mat-form-field class="quanControl drop-padding">
          <mat-label>Кол-во</mat-label>
          <input
            matInput
            type="number"
            name="quan"
            (keypress)="focusNext($event, index, 'quan')"
            (input)="handleControlChanges(getProductGroupControl(product))"
            [formControl]="getQuanControl(getProductGroupControl(product))"
          />
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>{{ getColSum() }}</td>
    </ng-container>
    <ng-container matColumnDef="stock">
      <th mat-header-cell *matHeaderCellDef>Кол-во</th>
      <td mat-cell *matCellDef="let product">
        <app-product-stock-list [product]="product" [receiverWarehouseId]="mainWarehouse?.id"></app-product-stock-list>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="mainStock">
      <th mat-header-cell *matHeaderCellDef>На складе</th>
      <td mat-cell *matCellDef="let product">
        {{ getMainStock(product)?.quan }}
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="analogies">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let product">
        <button mat-icon-button (click)="openAnalogies(product)">
          <mat-icon>compare_arrows</mat-icon>
        </button>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="move">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let product">
        <div class="rowActions">
          <button mat-icon-button (click)="openMoveProd(product)" matTooltip="Движение товара">
            <mat-icon>timeline</mat-icon>
          </button>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="marketPlace">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let product">
        <div class="marketPlaceWrapper">
          <button
            mat-icon-button
            (click)="togglePublic(product.id)"
            [ngClass]="{ active: product.public, disable: !product.public }"
            [disabled]="isPublicLoading(product.id)"
          >
            <mat-icon *ngIf="isPublicLoading(product.id)"
              ><mat-spinner [diameter]="24"></mat-spinner
            ></mat-icon>
            <img *ngIf="!isPublicLoading(product.id)" src="assets/logo.svg" alt="" />
          </button>
          <button
            mat-icon-button
            (click)="toggleProm(product.id)"
            [ngClass]="{ active: product.prom, disable: !product.prom }"
            [disabled]="isPromLoading(product.id)"
          >
            <mat-icon *ngIf="isPromLoading(product.id)"
              ><mat-spinner [diameter]="24"></mat-spinner
            ></mat-icon>
            <img *ngIf="!isPromLoading(product.id)" src="assets/prom.svg" alt="" />
          </button>
          <button
            mat-icon-button
            (click)="toggleAvtopro(product.id)"
            [ngClass]="{ active: product.avtopro, disable: !product.avtopro }"
            [disabled]="isAvtoproLoading(product.id)"
          >
            <mat-icon *ngIf="isAvtoproLoading(product.id)"
              ><mat-spinner [diameter]="24"></mat-spinner
            ></mat-icon>
            <img *ngIf="!isAvtoproLoading(product.id)" src="assets/avtopro.svg" alt="" />
          </button>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="cell">
      <th mat-header-cell *matHeaderCellDef>Адрес</th>
      <td mat-cell *matCellDef="let product">
        <div class="cellColumn">
          <button type="button" class="cellTitleButton" (click)="openStockDetails(product)">
            {{ getAddressLabel(product) || 'Нет размещения' }}
          </button>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="cellControl">
      <th mat-header-cell *matHeaderCellDef>Адрес</th>
      <td mat-cell *matCellDef="let product; let index = dataIndex">
        <mat-form-field class="cellControl drop-padding">
          <mat-label>Адрес</mat-label>
          <input
            matInput
            type="text"
            name="cell"
            (keypress)="focusNext($event, index, 'cell')"
            (input)="handleControlChanges(getProductGroupControl(product))"
            [formControl]="getCellControl(getProductGroupControl(product))"
          />
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let product">
        <mat-checkbox
          [disabled]="isLoading(product)"
          [checked]="isSelected(product)"
          (change)="toggleProduct(product)"
        >
        </mat-checkbox>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="remove">
      <th mat-header-cell *matHeaderCellDef>Удалить</th>
      <td mat-cell *matCellDef="let product">
        <button
          [disabled]="isLoading(product)"
          mat-icon-button
          (click)="remove(product)"
          color="warn"
        >
          <mat-icon>remove</mat-icon>
        </button>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="selector">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td class="cartWrapper" mat-cell *matCellDef="let product; let index = dataIndex">
        <button
          mat-icon-button
          *ngIf="!productInCart(product.id)"
          (click)="addToCart(product)"
          color="primary"
        >
          <mat-icon>add_shopping_cart</mat-icon>
        </button>
        <mat-form-field *ngIf="productInCart(product.id)" class="drop-padding quanCatalogue">
          <mat-label>Кол-во</mat-label>
          <input
            matInput
            type="number"
            [formControl]="getProductCartControl(product.id)"
            (input)="changeCartQuan(product, $event)"
            (keypress)="focusNext($event, index, 'quan')"
            name="quan"
            placeholder="Кол-во"
          />
          <button
            matSuffix
            mat-icon-button
            color="warn"
            aria-label="Удалить"
            type="button"
            (click)="removeFromCart(product)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <tr class="tableHeader" mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
    <tr mat-row *matRowDef="let product; columns: columnsToDisplay" class="product-row"></tr>
    <tr mat-footer-row *matFooterRowDef="columnsToDisplay; sticky: true"></tr>
  </table>
  <div
    style="visibility: hidden; position: fixed"
    [style.left]="menuTopLeftPosition.x"
    [style.top]="menuTopLeftPosition.y"
    [matMenuTriggerFor]="rightMenu"
  ></div>
  <mat-menu #rightMenu="matMenu">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item (click)="setNewPrice(item)">
        <mat-icon>edit</mat-icon> Новая цена
      </button>
      <button mat-menu-item (click)="updateName(item)">
        <mat-icon>edit</mat-icon> Изменить наименование
      </button>
      <button mat-menu-item (click)="addImage(item)">
        <mat-icon>image</mat-icon> Добавить изображение
      </button>
      <button
        mat-menu-item
        (click)="importFromExist(item)"
        [disabled]="isImportingFromExist(item.id)"
      >
        <mat-icon *ngIf="!isImportingFromExist(item.id)">cloud_download</mat-icon>
        <mat-spinner *ngIf="isImportingFromExist(item.id)" diameter="18"></mat-spinner>
        Загрузить с Exist
      </button>
      <button mat-menu-item (click)="removeDouble(item)">
        <mat-icon>remove</mat-icon> Удалить двойноую карточку
      </button>
      <button mat-menu-item (click)="addBarcode(item)">
        <mat-icon>qr_code</mat-icon> Добавить штрих-код
      </button>
      <button mat-menu-item (click)="quickPrintLabel(item)">
        <mat-icon>print</mat-icon> Распечатать штрих-код
      </button>
      <button
        mat-menu-item
        *ngIf="false"
        [matMenuTriggerFor]="priceLabelSize"
        [matMenuTriggerData]="{item}"
      >
        <mat-icon>sell</mat-icon> Распечатать ценник
      </button>
      <button mat-menu-item (click)="openMoveProd(item)">
        <mat-icon>timeline</mat-icon> Движение товара
      </button>
      <button mat-menu-item (click)="editProductInWarehouse(item)">
        <mat-icon>warehouse</mat-icon> Изменить адрес хранения
      </button>
      <button mat-menu-item (click)="togglePublic(item.id)">
        <mat-icon>public</mat-icon> {{ item.public ? 'Скрыть с продаж' : 'Отрыть для продаж' }}
      </button>
      <button mat-menu-item (click)="openFolders(item)"><mat-icon>folder</mat-icon> Папки</button>
      <button mat-menu-item (click)="openProps(item)">
        <mat-icon>settings</mat-icon> Характеристики
      </button>
    </ng-template>
  </mat-menu>

  <mat-menu #labelSize="matMenu">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item (click)="quickPrintLabel(item)">30x20</button>
      <button mat-menu-item (click)="quickPrintLabel(item)">58x40</button>
    </ng-template>
  </mat-menu>

  <mat-menu #priceLabelSize="matMenu">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item (click)="quickPrintLabel(item)">30x20</button>
      <button mat-menu-item (click)="quickPrintLabel(item)">58x40</button>
    </ng-template>
  </mat-menu>
</div>
<img id="barcode" />
